import Vue from 'vue'
import Vuex from 'vuex'
import rest from '../rest'

import usedCar from './modules/usedCar'
import carRegister from './modules/carRegister'
import barriergate from './modules/barriergate'
import appointment from './modules/appointment'
import conditionReport from './modules/conditionReport'
import rank from './modules/rank'
import cou from './modules/cou'
import salesReceptions from './modules/salesReceptions'
import aftersales from './modules/aftersales'
Vue.use(Vuex)

const state = {
  auctionCarInfo: {},
  carId: '', // 车辆id
  timeOut: null,
  carModelConfig: '',
  authList: [], // 权限列表
  userName: '', // 用户名
  id: '', // 客户id
  isPendingConfirm: true, // 新增的按钮权限
  selectStatus: '1', // 数字项下拉选项的状态管理
  loading: {
    status: false,
    text: '',
    time: 0
  },
  direction: 'forward',
  auctionManageStatus: 'pending',
  carManageStatus: 'all',
  matchManageStatus: 'created',
  // 询价撮合模块里面默认值
  enquiryManageStatus: 'created',
  customized: undefined, // 网站定制
  isDOS: false, // 是否是dos网站
  canViewReferPrice: false, // 是否能查看平台参考价
  stores_config: [],
  isShowView: true, // 是否显示页面
  isShowChangeStore: false, // 是否显示切换门店弹框
  curStoreName: '', // 当前门店名
  changeStoreName: '', // 切换门店名
  fromStoreId: '' // 地址栏门店id参数
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations: {
    UPDATE_AUCTION_INFO(state, info) {
      state.auctionCarInfo = info
    },
    UPDATE_TIMEOUT (state, data) {
      state.timeOut = data
    },
    UPDATE_SELECTSTATUS (state, data) {
      state.selectStatus = data
    },
    UPDATE_CARMODELCONFIG (state, data) {
      state.carModelConfig = data
    },
    // 获取权限列表
    UPDATE_AUTH (state, infoObj) {
      state.promiseAuth = infoObj
    },
    UPDATE_LOADING (state, loading) {
      state.loading = Object.assign({}, state.loading, loading)
    },
    UPDATE_DIRECTION (state, direction) {
      state.direction = direction
    },
    // 更新网站定制
    UPDATE_CUSTOMIZED (state, customized) {
      state.isDOS = customized.group_config && !customized.group_config.is_zs_group
      state.customized = customized
      state.stores_config = state.customized.stores_config
      state.canViewReferPrice = customized.group_config && customized.group_config.can_view_refer_price
    },
    UPDATE_AUCTION_MANAGE_STATUS (state, status) {
      state.auctionManageStatus = status
    },
    UPDATE_CAR_MANAGE_STATUS (state, status) {
      state.carManageStatus = status
    },
    UPDATE_MATCH_MANAGE_STATUS (state, status) {
      state.matchManageStatus = status
    },
    UPDATE_ENQUIRY_MANAGE_STATUS(state, status) {
      state.enquiryManageStatus = status
    },
    UPDATE_IS_SHOW_VIEW(state, status) {
      state.isShowView = status
    },
    UPDATE_IS_SHOW_CHANGE_STORE(state, status) {
      state.isShowChangeStore = status
    },
    UPDATE_CUR_STORE_NAME(state, curStoreName) {
      state.curStoreName = curStoreName
    },
    UPDATE_CHANGE_STORE_NAME(state, changeStoreName) {
      state.changeStoreName = changeStoreName
    },
    UPDATE_FROM_STORE_ID(state, fromStoreId) {
      state.fromStoreId = fromStoreId
    }
  },
  actions: {
    UPDATE_LOADING ({ commit }, loading) {
      commit('UPDATE_LOADING', loading)
      if (loading && loading.time) {
        let st = null
        clearTimeout(st)
        st = setTimeout(() => {
          loading.show = false
          commit('UPDATE_LOADING', loading)
        }, loading.time)
      }
    },
    UPDATE_CUSTOMIZED({ commit }) {
      return rest.auth.getCustomized(null).then(res => {
        if (res.code === 0) {
          commit('UPDATE_CUSTOMIZED', res.data)
        }
      })
    }
  },
  modules: {
    usedCar,
    carRegister,
    barriergate,
    appointment,
    conditionReport,
    rank,
    cou,
    salesReceptions,
    aftersales
  }
})
